import { JsonRecord } from 'libs/cms/parse/types';

export const getSpecDownloadHref = (spec: JsonRecord): string => {
  const encodedJsonStringSpec = encodeURIComponent(JSON.stringify(spec));

  return `data:text/plain;charset=utf-8, ${encodedJsonStringSpec}`;
};

export const getSpecFileName = (apiId: string): string =>
  `${apiId}-specification.json`;
